import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { AuthShell } from "@/pages/auth/AuthShell";
import { OtpStep } from "@/pages/auth/OtpStep";
import { useAfterLogin } from "@/pages/auth/Login";
import { api, errMsg } from "@/lib/api";

export default function Register() {
  const [f, setF] = useState({ name: "", email: "", company_name: "", password: "", confirm: "" });
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  const [challenge, setChallenge] = useState(null);
  const done = useAfterLogin();
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.password !== f.confirm) return toast.error("Passwords do not match");
    if (!agree) return toast.error("Please accept the Terms and Privacy Policy");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/register", { name: f.name, email: f.email, company_name: f.company_name, password: f.password });
      setChallenge(data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title={challenge ? "Verify your email" : "Create your free account"} subtitle={challenge ? "Enter the code we emailed you" : "Explore Sliance with 100 trial AI credits. No payment required."}>
      {challenge ? (
        <OtpStep challenge={challenge} onSuccess={done} onBack={() => setChallenge(null)} />
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="space-y-2"><Label>Your name</Label><Input required value={f.name} onChange={set("name")} data-testid="register-name-input" /></div>
            <div className="space-y-2"><Label>Company</Label><Input required value={f.company_name} onChange={set("company_name")} data-testid="register-company-input" /></div>
          </div>
          <div className="space-y-2"><Label>Work email</Label><Input type="email" required value={f.email} onChange={set("email")} data-testid="register-email-input" /></div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="space-y-2"><Label>Password</Label><Input type="password" minLength={8} required value={f.password} onChange={set("password")} data-testid="register-password-input" /></div>
            <div className="space-y-2"><Label>Confirm</Label><Input type="password" minLength={8} required value={f.confirm} onChange={set("confirm")} data-testid="register-password-confirm-input" /></div>
          </div>
          <label className="flex items-start gap-3 text-xs text-muted-foreground cursor-pointer">
            <Checkbox checked={agree} onCheckedChange={(v) => setAgree(!!v)} data-testid="register-terms-checkbox" className="mt-0.5" />
            <span>I agree to the <Link to="/legal/terms" target="_blank" className="underline">Terms of Service</Link> and <Link to="/legal/privacy" target="_blank" className="underline">Privacy Policy</Link> (GDPR-aligned).</span>
          </label>
          <button disabled={busy} className="btn-brand w-full disabled:opacity-60" data-testid="register-submit-button">{busy ? "Creating..." : "Create account"}</button>
          <p className="text-sm text-muted-foreground text-center">Already have an account? <Link to="/login" className="font-semibold text-[#7c3aed]" data-testid="register-login-link">Log in</Link></p>
        </form>
      )}
    </AuthShell>
  );
}
